import{IBAN_PREFIX as n}from"../../../../../common/components/FormFields/IbanField.js";var o=(o,a)=>({id:a,...o,iban:`${n}${o.iban}`});export{o as buildOrganizationBankAccountRequest};
//# sourceMappingURL=utils.js.map